import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Indicator from "src/components/layout/Indicator";
import usePlans from "src/hooks/api/usePlans";

interface SubscriptionIntervalSwitchProps extends Translation {}

const SubscriptionIntervalSwitch = ({ t }: SubscriptionIntervalSwitchProps) => {
	const { interval, actions } = usePlans();
	return (
		<div className="flex justify-center items-center">
			<div className="rounded-md p-4 gap-2 bg-white flex items-center shadow">
				<IntervalItem
					onClick={() => actions.setInterval("MONTHLY")}
					active={interval === "MONTHLY"}
				>
					{t("monthly")}
				</IntervalItem>
				<IntervalItem
					onClick={() => actions.setInterval("YEARLY")}
					active={interval === "YEARLY"}
				>
					<Indicator className="rounded-md absolute w-max -top-4 -right-16 py-3">
						{t("save")}
					</Indicator>
					{t("yearly")}
				</IntervalItem>
			</div>
		</div>
	);
};

interface IntervalItemProps {
	children?: any;
	active: boolean;
	onClick: () => void;
}

const IntervalItem = ({ children, active, onClick }: IntervalItemProps) => {
	return (
		<div
			className={`px-4 py-2 transition-all rounded-md cursor-pointer relative ${
				active ? "bg-dark text-white" : "bg-white text-dark"
			}`}
			{...{ onClick }}
		>
			{children}
		</div>
	);
};

SubscriptionIntervalSwitch.locale = {
	nl: {
		monthly: "Maandelijks",
		yearly: "Jaarlijks",
		save: "Bespaar 30%",
	},
	en: {
		monthly: "Monthly",
		yearly: "Yearly",
		save: "Save 30%",
	},
};

export default withTranslation(SubscriptionIntervalSwitch);
